import axios, { AxiosResponse } from 'axios';
import { ApiResponse, zps_wp } from '../zps';

export type Reason = {
  gid: number;
  entid: number;
  langid: number;
  code: number;
  reason: string;
};

export type Declaration = {
  gid: number;
  entid: number;
  langid: number;
  code: number;
  declaration: string;
};

export interface EquipmentReasonsResponse extends ApiResponse {
  reasons: Reason[];
  type: string;
}

export interface EquipmentDeclarationResponse extends ApiResponse {
  declarations: Declaration[];
  type: string;
}

export const fetchEquipmentReasons = (
  controller: AbortController,
  entid: number
): Promise<AxiosResponse<EquipmentReasonsResponse>> => {
  return axios.get<EquipmentReasonsResponse>(`${zps_wp}/api/deposit/reason`, {
    params: { entid },
    signal: controller.signal
  });
};

export const fetchEquipmentDeclarations = (
  controller: AbortController,
  entid: number
): Promise<AxiosResponse<EquipmentDeclarationResponse>> => {
  return axios.get<EquipmentDeclarationResponse>(`${zps_wp}/api/deposit/declaration`, {
    params: { entid },
    signal: controller.signal
  });
};

export const addEquipmentReason = (
  controller: AbortController,
  payload: Reason
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.post<ApiResponse>(`${zps_wp}/api/deposit/reason`, payload, {
    signal: controller.signal
  });
};

export const addEquipmentDeclaration = (
  controller: AbortController,
  payload: Declaration
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.post<ApiResponse>(`${zps_wp}/api/deposit/declaration`, payload, {
    signal: controller.signal
  });
};

export const updateEquipmentReason = (
  controller: AbortController,
  payload: Reason
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.put<ApiResponse>(`${zps_wp}/api/deposit/reason`, payload, {
    signal: controller.signal
  });
};

export const updateEquipmentDeclaration = (
  controller: AbortController,
  payload: Declaration
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.put<ApiResponse>(`${zps_wp}/api/deposit/declaration`, payload, {
    signal: controller.signal
  });
};

export const deleteEquipmentReason = (
  entid: number,
  code: number,
  langid: number
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.delete<ApiResponse>(`${zps_wp}/api/deposit/reason`, {
    params: { entid, code, langid }
  });
};

export const deleteEquipmentDeclaration = (
  entid: number,
  code: number,
  langid: number
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.delete<ApiResponse>(`${zps_wp}/api/deposit/declaration`, {
    params: { entid, code, langid }
  });
};
